const userMenu = {
  'userMenu.english': 'Inglês',
  'userMenu.portuguese': 'Português',
  'userMenu.spanish': 'Espanhol',
  'userMenu.notifications': 'Notificações',
  'userMenu.help': 'Ajuda',
  'userMenu.exit': 'Sair',
  'userMenu.profile': 'Perfil',
  'userMenu.language': 'Idioma',
};

export default userMenu;
